import { TipoLimpieza } from "../../cleaning/limpiezaUtils";

export const CLEANING_LABELS: Record<TipoLimpieza, string> = {
  checkout: "S",
  intermedia: "L",
  manual: "P",
};

export const CLEANING_NAMES: Record<TipoLimpieza, string> = {
  checkout: "Salida",
  intermedia: "Intermedia",
  manual: "Pactada",
};
